export default __webpack_public_path__ + "static/media/ellip_target.2a1dd6aa.svg";